export default __webpack_public_path__ + "static/media/crystal_oscillator.b5de8ed4.png";